'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".Chevron-module_container__rgeIU{height:auto;width:1rem;fill:#000;vertical-align:middle}";
var styles = {"container":"Chevron-module_container__rgeIU"};
styleInject["default"](css_248z, 'a06d117a-74bf-4311-ba8a-1803d138dc14');

exports["default"] = styles;
